<ng-container *ngIf="vm$ | async as vm">
    <app-raised-button
        (onClick)="selectReport(vm.reportId)"
        [typeClass]="'danger'"
    >
        <i class="far fa-trash" *ngIf="!vm.deleting"></i>
        <i class="far fa-spin fa-spinner" *ngIf="vm.deleting"></i>
    </app-raised-button>
</ng-container>